var App = App || {};

var $RelatedPostSlider;

App.BlogPostRelated = (function ($) {
    'use strict';

    function init() {
        var BlogPostRelated = $(".blog-post-related-mobile");
        $RelatedPostSlider = BlogPostRelated.find(".blog-post-related-items");

        $(document).ready(function () {
            if ($RelatedPostSlider.length) {

                Flickity.createMethods.push('_createPrevNextCells');

                Flickity.prototype._createPrevNextCells = function () {
                    this.on('select', this.setPrevNextCells);
                };

                Flickity.prototype.setPrevNextCells = function () {
                    // remove classes
                    changeSlideClasses(this.previousSlide, 'remove', 'is-previous');
                    changeSlideClasses(this.nextSlide, 'remove', 'is-next');
                    // set slides
                    var previousI = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length);
                    var nextI = fizzyUIUtils.modulo(this.selectedIndex + 1, this.slides.length);
                    this.previousSlide = this.slides[previousI];
                    this.nextSlide = this.slides[nextI];
                    // add classes
                    changeSlideClasses(this.previousSlide, 'add', 'is-previous');
                    changeSlideClasses(this.nextSlide, 'add', 'is-next');
                };

                initImageCarousel();
            };
        });
    }

    function initImageCarousel() {
        $RelatedPostSlider.each(function () {
            var $this = $(this);

            $this.on('ready.flickity select.flickity', function (event, index) {
                $this
                    .find('.slide:not(.is-selected) > a')
                    .attr('tabindex', '-1')
                    .end()
                    .find('.slide.is-selected > a')
                    .attr('tabindex', '');
            });

            if (!$this.hasClass('flickity-enabled')) {
                $this.flickity({
                    adaptiveHeight: true,
                    draggable: true,
                    pageDots: true,
                    prevNextButtons: false,
                    wrapAround: false,
                    imagesLoaded: true,
                    selectedAttraction: 0.01,
                    friction: 0.15
                });
            }
        });
    }

    function changeSlideClasses(slide, method, className) {
        if (!slide) {
            return;
        }
        slide.getCellElements().forEach(function (cellElem) {
            cellElem.classList[method](className);
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.BlogPostRelated.init();
});